import { useEffect } from 'react'

import { useBoundStore } from '../store/store'
import { prefetchSportsLauncherUrl } from '../utils/sports-launcher'
import useDimensions from './useDimensions'

// Mints the sports ticket right after login so the first /sports visit is warm.
const useSportsPrefetch = () => {
  const username = useBoundStore(state => state.user.username)
  const isUserLoading = useBoundStore(state => state.user.isLoading)
  const { isDesktop } = useDimensions()

  useEffect(() => {
    if (isUserLoading || !username) return
    void prefetchSportsLauncherUrl({ isDesktop, username })
  }, [username, isUserLoading, isDesktop])
}

export default useSportsPrefetch
